// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { getBidderId } from '../../../redux/modules/user';
import queryString from 'query-string';
import { recordAnalyticsForCertCapturePageView } from '../../../redux/modules/analytics';
import { sleep } from '../../../utils/sleep';

export default ({ location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    return Promise.all([sleep(1500)]).then(() => {
        const state = getState();
        const bidderId = getBidderId(state);
        let parsed = queryString.parse(location.search);
        const shipZone = parsed.shipZone;
        return dispatch(recordAnalyticsForCertCapturePageView(bidderId, shipZone));
    });
};
